
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Header from "../components/common/Header";
import useTranslation from "next-translate/useTranslation";
import MainLayout from "../layouts/main";
import Footer from "../components/common/Footer";
const Item = ({ item }) => {
    return <div id={item.anchor} className={'terms_item'}>
        <h3 className={'terms_item_title'}>{item.title}</h3>
        {item.list && <ul className={'terms_item_list'}>
            {item.list.map((el, i) => {
                return <li className={'terms_item_list_item'} key={i}>
                    {el}
                </li>;
            })}
        </ul>}
        {item.sub_list && <ul className={'terms_item_sublist'}>
            {item.sub_list.map((el, i) => {
                return <li className={'terms_item_sublist_item'} key={i}>
                    {el}
                </li>;
            })}
        </ul>}

        {item.ps && <p className={'terms_item_ps'}>
            {item.ps}
        </p>}

    </div>;
};
const TermsOfUse = () => {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const terms = t('terms:content', {}, { returnObjects: true });
    return (<MainLayout title={seo.terms.title} description={seo.terms.description} keywords={seo.terms.keywords} page={'services terms'} alternate={'terms-of-use'} canonical={'/terms-of-use'} noindex={true}>
            <Header t={t}/>
            <main className='main'>
                <section className={'services_wrapper'}>
                    <div className="container">
                        <div className="services_content">
                            <h1 className={'services_title'}>{terms.title}</h1>
                            <h2 className={'terms_item_title'}>{terms.sub_title}</h2>
                            {terms.data.map(item => {
            return <Item key={item.title} item={item}/>;
        })}
                        </div>
                    </div>
                </section>
            </main>
            <Footer t={t}/>
        </MainLayout>);
};
export default TermsOfUse;

    async function __Next_Translate__getStaticProps__196f6e58c3a__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/terms-of-use',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196f6e58c3a__ as getStaticProps }
  